export enum Roles {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Manager = 'Manager',
  Instructor = 'Instructor',
  Creator = 'Creator',
  Player = 'Player',
}
